(function () {
  'use strict';
  if (window.EnigmaCartSelection) return;
  var selected = new Set();
  var knownKeys = null;

  function controller() { return window.EnigmaCartController; }
  function keyFor(input) {
    var row = input.closest('[data-cart-key]');
    return input.value || input.getAttribute('data-cart-key') || row && row.getAttribute('data-cart-key') || '';
  }
  function keys() {
    if (knownKeys) return knownKeys;
    var cart = controller() && controller().getCart();
    if (cart && Array.isArray(cart.items)) return new Set(cart.items.map(function(item) { return item.key; }));
    return new Set(Array.prototype.map.call(document.querySelectorAll('[data-cart-select-item]'), keyFor).filter(Boolean));
  }
  function busy() {
    return document.documentElement.hasAttribute('data-cart-mutating') || Boolean(controller() && controller().isBusy());
  }
  function sync() {
    var available = keys(), isBusy = busy();
    selected.forEach(function(key) { if (!available.has(key)) selected.delete(key); });
    document.querySelectorAll('[data-cart-select-item]').forEach(function(input) {
      var key = keyFor(input);
      input.checked = selected.has(key);
      input.disabled = isBusy || !available.has(key);
    });
    document.querySelectorAll('[data-cart-select-all]').forEach(function(input) {
      input.checked = available.size > 0 && selected.size === available.size;
      input.indeterminate = selected.size > 0 && selected.size < available.size;
      input.disabled = isBusy || available.size === 0;
    });
    document.querySelectorAll('[data-cart-remove-selected]').forEach(function(button) {
      button.disabled = isBusy || selected.size === 0;
      button.setAttribute('aria-disabled', String(button.disabled));
    });
    document.querySelectorAll('[data-cart-clear]').forEach(function(button) {
      button.disabled = isBusy || available.size === 0;
      button.setAttribute('aria-disabled', String(button.disabled));
    });
    document.querySelectorAll('[data-cart-selection-status]').forEach(function(status) {
      var template = status.getAttribute('data-template') || '__COUNT__';
      var text = template.replace(/__COUNT__/g, String(selected.size));
      if (status.textContent !== text) status.textContent = text;
    });
  }

  document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input.matches('[data-cart-select-item], [data-cart-select-all]')) return;
    if (busy()) { sync(); return; }
    if (input.matches('[data-cart-select-all]')) {
      selected.clear();
      if (input.checked) keys().forEach(function(key) { selected.add(key); });
    } else {
      var key = keyFor(input);
      if (input.checked && keys().has(key)) selected.add(key);
      else selected.delete(key);
    }
    sync();
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-cart-remove-selected], [data-cart-clear]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || busy() || !controller()) return;
    var operation = button.matches('[data-cart-clear]')
      ? controller().clear() : controller().removeItems(Array.from(selected));
    // The controller announces failures and rehydrates confirmed quantities.
    Promise.resolve(operation).catch(function() {}).finally(sync);
  });

  document.addEventListener('enigma:cart-updated', function(event) {
    var cart = event.detail && event.detail.cart;
    if (cart && Array.isArray(cart.items)) knownKeys = new Set(cart.items.map(function(item) { return item.key; }));
    sync();
  });
  document.addEventListener('enigma:cart-busy', sync);
  document.addEventListener('shopify:section:load', sync);
  window.EnigmaCartSelection = { sync: sync };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
